<template>
  <div id="page" class="site">
    <app-header></app-header>
    <app-mobile-header></app-mobile-header>
    <transition name="fade" mode="out-in">
      <router-view :key="$route.params.page" />
    </transition>
    <cookie-law
      buttonText="OK rozumiem"
      message="Serwis wykorzystuje pliki cookies. Korzystając ze strony wyrażasz
zgodę na wykorzystywanie plików cookies. <a href='#'>Dowiedz się
więcej</a>"
    >
      <div slot="message">
        Serwis wykorzystuje pliki cookies. Korzystając ze strony wyrażasz
        zgodę na wykorzystywanie plików cookies.
        <router-link to="polityka-prywatnosci">
          Dowiedz się
          więcej
        </router-link>
      </div>
    </cookie-law>
  </div>
</template>
<script>
import CookieLaw from "vue-cookie-law";
import AppHeader from "./views/AppHeader.vue";
import AppMobileHeader from "./views/AppMobileHeader.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "amaapp",
  methods: {},
  head: {
    title: function() {
      return {
        inner: this.pageTitle
        // separator: " - "
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content:
            this.pageDesc !== ""
              ? this.pageDesc
              : "Pracownia architektoniczna, której kluczowym profilem działalności jest kreowanie wnętrz komercyjnych. Tworzymy wyjątkowe projekty lokali handlowo-usługowych, sklepów, biur.",
          id: "desc"
        }
      ];
    }
  },
  computed: {
    pageTitle() {
      return this.$store.state.page.pageTitle;
    },
    pageDesc() {
      return this.$store.state.page.pageDesc;
    }
  },
  watch: {
    pageTitle: function(npageTitle) {
      this.$emit("updateHead");
    },
    pageDesc: function(npageDesc) {
      this.$emit("updateHead");
    }
  },
  components: {
    "app-mobile-header": AppMobileHeader,
    "app-header": AppHeader,
    CookieLaw
  },
  mounted() {
    window.addEventListener("click", event => {
      const { target } = event;
      // handle only links that do not reference external resources
      if (target && target.matches("a:not([href*='://'])") && target.href) {
        // some sanity checks taken from vue-router:
        // https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
        const {
          altKey,
          ctrlKey,
          metaKey,
          shiftKey,
          button,
          defaultPrevented
        } = event;
        // don't handle with control keys
        if (metaKey || altKey || ctrlKey || shiftKey) return;
        // don't handle when preventDefault called
        if (defaultPrevented) return;
        // don't handle right clicks
        if (button !== undefined && button !== 0) return;
        // don't handle if `target="_blank"`
        if (target && target.getAttribute) {
          const linkTarget = target.getAttribute("target");
          if (/\b_blank\b/i.test(linkTarget)) return;
        }
        // don't handle same page links/anchors
        const url = new URL(target.href);
        const to = url.pathname;
        if (window.location.pathname !== to && event.preventDefault) {
          event.preventDefault();
          this.$router.push(to);
        }
      }
    });
  }
};
</script>
<style lang="scss">
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
